var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "设置二级坑位",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "batch-set-pit",
            },
            [
              _c(
                "div",
                { staticClass: "config-row" },
                [
                  _c(
                    "div",
                    { staticClass: "config-item" },
                    [
                      _c("span", { staticClass: "config-label" }, [
                        _vm._v("总坑位数量"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        on: {
                          input: _vm.onHandleNeedCompute,
                          blur: function ($event) {
                            return _vm.onHandleConfigBlur("total_slot")
                          },
                        },
                        model: {
                          value: _vm.configForm.total_slot,
                          callback: function ($$v) {
                            _vm.$set(_vm.configForm, "total_slot", $$v)
                          },
                          expression: "configForm.total_slot",
                        },
                      }),
                      _c("span", { staticClass: "config-unit" }, [
                        _vm._v("个"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "config-item" },
                    [
                      _c("span", { staticClass: "config-label" }, [
                        _vm._v("采购保底坑位数量"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        on: {
                          input: _vm.onHandleNeedCompute,
                          blur: function ($event) {
                            return _vm.onHandleConfigBlur("guarantee_slot")
                          },
                        },
                        model: {
                          value: _vm.configForm.guarantee_slot,
                          callback: function ($$v) {
                            _vm.$set(_vm.configForm, "guarantee_slot", $$v)
                          },
                          expression: "configForm.guarantee_slot",
                        },
                      }),
                      _c("span", { staticClass: "config-unit" }, [
                        _vm._v("个"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "config-item ratio-item" },
                    [
                      _c("span", { staticClass: "config-label" }, [
                        _vm._v("招商/买手坑位比例"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        on: {
                          input: _vm.onHandleNeedCompute,
                          blur: function ($event) {
                            return _vm.onHandleConfigBlur("merchant_ratio")
                          },
                        },
                        model: {
                          value: _vm.configForm.merchant_ratio,
                          callback: function ($$v) {
                            _vm.$set(_vm.configForm, "merchant_ratio", $$v)
                          },
                          expression: "configForm.merchant_ratio",
                        },
                      }),
                      _c("span", { staticClass: "ratio-separator" }, [
                        _vm._v(":"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        on: {
                          input: _vm.onHandleNeedCompute,
                          blur: function ($event) {
                            return _vm.onHandleConfigBlur("buyer_ratio")
                          },
                        },
                        model: {
                          value: _vm.configForm.buyer_ratio,
                          callback: function ($$v) {
                            _vm.$set(_vm.configForm, "buyer_ratio", $$v)
                          },
                          expression: "configForm.buyer_ratio",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.computeLoading },
                      on: { click: _vm.onHandleCompute },
                    },
                    [_vm._v(" 确定 ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "list-wrap" },
                [
                  _vm.listData.length
                    ? [
                        _vm.buyerList.length
                          ? _c(
                              "div",
                              { staticClass: "group-block" },
                              [
                                _c("div", { staticClass: "group-title" }, [
                                  _vm._v("买手采购："),
                                ]),
                                _vm._l(_vm.buyerList, function (item) {
                                  return _c(
                                    "div",
                                    { key: item.id, staticClass: "buyer-row" },
                                    [
                                      _c("div", { staticClass: "buyer-name" }, [
                                        _vm._v(_vm._s(item.fullname)),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "buyer-slot-label" },
                                        [_vm._v("坑位")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "slot-value" },
                                        [_vm._v(_vm._s(item.slot))]
                                      ),
                                      _c("el-switch", {
                                        staticClass: "whitelist-switch",
                                        attrs: {
                                          "active-value": 1,
                                          "inactive-value": 0,
                                        },
                                        on: { change: _vm.onHandleNeedCompute },
                                        model: {
                                          value: item.slot_is_whitelist,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "slot_is_whitelist",
                                              $$v
                                            )
                                          },
                                          expression: "item.slot_is_whitelist",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "switch-label" },
                                        [_vm._v("白名单")]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.merchantList.length
                          ? _c(
                              "div",
                              { staticClass: "group-block" },
                              [
                                _c("div", { staticClass: "group-title" }, [
                                  _vm._v("招商采购："),
                                ]),
                                _vm._l(_vm.merchantList, function (item) {
                                  return _c(
                                    "div",
                                    { key: item.id, staticClass: "buyer-row" },
                                    [
                                      _c("div", { staticClass: "buyer-name" }, [
                                        _vm._v(_vm._s(item.fullname)),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "buyer-slot-label" },
                                        [_vm._v("坑位")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "slot-value" },
                                        [_vm._v(_vm._s(item.slot))]
                                      ),
                                      _c("el-switch", {
                                        staticClass: "whitelist-switch",
                                        attrs: {
                                          "active-value": 1,
                                          "inactive-value": 0,
                                        },
                                        on: { change: _vm.onHandleNeedCompute },
                                        model: {
                                          value: item.slot_is_whitelist,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "slot_is_whitelist",
                                              $$v
                                            )
                                          },
                                          expression: "item.slot_is_whitelist",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "switch-label" },
                                        [_vm._v("白名单")]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  !_vm.listLoading && _vm.listData.length === 0
                    ? _c("div", { staticClass: "empty-text" }, [
                        _vm._v(" 暂无数据 "),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.submitLoading,
                    disabled: _vm.needCompute,
                  },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }